import React from 'react';
import { useTranslations } from '../hooks/useTranslations';
export function LogoSlider() {
  const {
    t
  } = useTranslations();
  const logos = [{
    name: 'EXPERIAN',
    width: 'w-32'
  }, {
    name: 'EQUIFAX',
    width: 'w-28'
  }, {
    name: 'TRANSUNION',
    width: 'w-36'
  }, {
    name: 'MYSCOREIQ',
    width: 'w-32'
  }, {
    name: 'IDENTITYIQ',
    width: 'w-36'
  }];
  return <section className="py-12 bg-gray-50 border-y border-gray-100 overflow-hidden" data-id="element-299">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6" data-id="element-300">
        <p className="text-center text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-301">
          {t('logoSlider.title')}
        </p>
      </div>

      <div className="relative" data-id="element-302">
        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-10" data-id="element-303" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-10" data-id="element-304" />

        {/* Scrolling Container */}
        <div className="flex animate-scroll-infinite" data-id="element-305">
          {/* First Set */}
          <div className="flex items-center justify-around min-w-full gap-16 px-8" data-id="element-306">
            {logos.map((logo, index) => <div key={`first-${index}`} className={`${logo.width} flex items-center justify-center grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300`} data-id="element-307">
                <span className="text-2xl font-bold text-gray-400 tracking-tight" data-id="element-308">
                  {logo.name}
                </span>
              </div>)}
          </div>

          {/* Duplicate Set for Seamless Loop */}
          <div className="flex items-center justify-around min-w-full gap-16 px-8" data-id="element-309">
            {logos.map((logo, index) => <div key={`second-${index}`} className={`${logo.width} flex items-center justify-center grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300`} data-id="element-310">
                <span className="text-2xl font-bold text-gray-400 tracking-tight" data-id="element-311">
                  {logo.name}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}